<script setup>
import { ref } from 'vue';
import supportForm from './form.vue'
import faqCard from './faq.vue'
const support = ref({
  topic: '',
  subject: '',
  message: ''
})
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Support Ticket"/>
    <div v-auto-animate>
      <supportForm />
    </div>
  </div>
</template>